<template>
    <div class="cost">
        <header>
            <Header />
        </header>
        <div class="cost-content-box">
            <div class="content-box-data">
                <div class="cost-box">
                    <div class="cost-box-title">个人中心</div>
                    <div class="cost-box-desc">管理您的账户信息和资源购买信息</div>
                </div>
                <el-card class="box-card">
                    <el-tabs tab-position="left">
                        <el-tab-pane label="账号信息">
                            <UserTable />
                        </el-tab-pane>
                        <!-- <el-tab-pane label="消费信息管理">
                            <ExpenseTable />
                        </el-tab-pane>
                        <el-tab-pane label="发票管理">
                            <InvoiceTable />
                        </el-tab-pane> -->
                        <el-tab-pane label="需求发布">
                            <DemandRelease />
                        </el-tab-pane>
                        <el-tab-pane label="资源订单">
                            <PayTable />
                        </el-tab-pane>
                    </el-tabs>
                </el-card>
            </div>
        </div>
        
    </div>
</template>

<script>
import Header from '../../components/header.vue';
import UserTable from './userAccount.vue'
// import ExpenseTable from './Demand/expense.vue';
// import InvoiceTable from './Demand/invoice.vue';
import PayTable from './Demand/pay.vue';
import DemandRelease from './Demand/release.vue'
export default {
    // name:'个人中心-需求用户',
    components: {
		Header,
        UserTable,
        // ExpenseTable,
        // InvoiceTable,
        PayTable,
        DemandRelease,
	},
    data() {
        return {
        
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>
<style lang="scss" scoped>
.cost-content-box{
    width: 100%;
	height:auto;
    min-height:calc(100vh - 140px);
	padding:30px 0 20px;
	background-color: #f9fafb;
    .content-box-data{
        width:80%;
        height:auto;
        margin:0 auto;
        // background-color:#fff;
        .cost-box{
            width:100%;
            height:auto;
            margin-bottom:20px;
            box-sizing: border-box;
            padding:20px 20px;
            border-radius:5px;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            background-color:#fff;
            .cost-box-title{
                font-size:1.25rem;
                font-weight:600;
                color:#000;
            }
            .cost-box-desc{
                font-size:0.8rem;
                color:#666;
                margin-top:10px;
            }
        }
        // .box-card-title{
        //     width: 100%;
        //     font-size:0.8rem;
        //     font-weight:600;
        //     text-align: center;
        //     margin-bottom:20px;
        // }
        // .cost-form{
        //     width:500px;
        //     height:auto;
        //     margin:0 auto;
        // }
    }
}
</style>